import { call, take, takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource,
  qcsSyncDeleteResource, qcsSyncUpdateResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';
import { transformResponseToCategories, transformCategoryToRequestData } from './transformers';

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'category',
  resourceBaseUrl: '/categories',
  getLastSyncDate,

  transformResponseToResources: transformResponseToCategories,
  transformResourceToRequestData: transformCategoryToRequestData,

  successAction,
  failureAction,
});

export function* getCategoriesActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  while (true) {
    const action = yield take(actions.getCategories);

    const config = mkResourceConfig(actions.getCategoriesSuccess, actions.getCategoriesFailure);
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createCategoryActionWatcher() {
  const config = mkResourceConfig(actions.createCategorySuccess, actions.createCategoryFailure);
  yield takeEvery(actions.createCategory, qcsSyncCreateResource, config);
}

export function* updateCategoryActionWatcher() {
  const config = mkResourceConfig(actions.updateCategorySuccess, actions.updateCategoryFailure);
  yield takeEvery(actions.updateCategory, qcsSyncUpdateResource, config);
}

export function* updateCategoriesActionWatcher() {
  const config = mkResourceConfig(actions.updateCategoriesSuccess, actions.updateCategoriesFailure);
  yield takeEvery(actions.updateCategories, qcsSyncUpdateResources, config);
}

export function* deleteCategoryActionWatcher() {
  const config = mkResourceConfig(actions.deleteCategorySuccess, actions.deleteCategoryFailure);
  yield takeEvery(actions.deleteCategory, qcsSyncDeleteResource, config);
}

// ====================================================
// EXPORTS

export default [
  getCategoriesActionWatcher,
  createCategoryActionWatcher,
  updateCategoryActionWatcher,
  updateCategoriesActionWatcher,
  deleteCategoryActionWatcher,
];
